// ── src/lib/upload.ts ──
// 通用檔案上傳工具：multipart 上傳到本地後端，回傳 URL（取代 base64）

import { getToken } from "./authToken";

const API_URL = import.meta.env.VITE_API_URL || "";

/**
 * 上傳圖片到本地後端，回傳可存取的 URL。
 * 取代 base64 邏輯：不佔 DOM 記憶體、瀏覽器可快取、儲存體積小。
 */
export async function uploadImage(file: File): Promise<string> {
  const formData = new FormData();
  formData.append("file", file);

  const token = getToken();
  const headers: Record<string, string> = {};
  if (token) headers["Authorization"] = `Bearer ${token}`;

  const response = await fetch(`${API_URL}/api/functions/upload-chat-image`, {
    method: "POST",
    headers,
    body: formData,
  });

  const result = await response.json().catch(() => ({})) as {
    success?: boolean;
    url?: string;
    error?: string;
  };

  if (!response.ok || !result.success || !result.url) {
    throw new Error(result.error || "圖片上傳失敗，請稍後再試");
  }

  // 回傳完整 URL（後端靜態檔案服務在 /uploads/）
  return `${API_URL}${result.url}`;
}
